import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core/styles';
import { colors } from '@skyslope/mache';
import { IBlock } from '../store/types';
import { IS_MOBILE } from '../common/constants';

const useStyles = makeStyles((theme: Theme) => ({
  nextButton: {
    zIndex: 4,
    padding: `${IS_MOBILE ? '4px 8px' : '4px 24px'}`,
    right: '100%',
    width: `${IS_MOBILE ? '16px' : '36px'}`,
    backgroundColor: colors.blue[600],
    color: '#ffffff',
    fontSize: `${IS_MOBILE ? '12px' : '16px'}`,
    fontWeight: 'bold',
    height: `${IS_MOBILE ? '12px' : '24px'}`,
    userSelect: 'none',
    cursor: 'pointer',
    transform: 'translateY(-50%)',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:after': {
      content: '""',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: `${IS_MOBILE ? '10px 0 10px 10px' : '16px 0 16px 16px'}`,
      borderColor: `transparent transparent transparent ${colors.blue[600]}`,
      position: 'absolute',
      left: '100%',
      top: 0,
    },
  },
}));

interface IProps {
  zoom: number;
  selectedBlock?: IBlock;
  currentSelectedBlockIndex: number | null;
  documentIndex: number;
  documentId: string;
  onClick: () => void;
  pageDimensions: { height?: number; width?: number };
}

export default (props: IProps) => {
  const classes = useStyles();
  const arrowRef = React.useRef<HTMLDivElement>(null);
  const [isArrowInside, setIsArrowInside] = React.useState(false);

  const checkIfArrowIsVisible = () => {
    if (!arrowRef.current) {
      return;
    }
    const rect = arrowRef.current!.getBoundingClientRect();
    if (isArrowInside && rect.left > 84) {
      setIsArrowInside(false);
    } else if (!isArrowInside && rect.left <= 0) {
      setIsArrowInside(true);
    }
  };

  React.useEffect(() => {
    const fnWrapper = () => checkIfArrowIsVisible();
    window.addEventListener('resize', fnWrapper);
    setTimeout(() => {
      checkIfArrowIsVisible();
    }, 0);
    return () => window.removeEventListener('resize', fnWrapper);
  }, [isArrowInside, props.zoom]);

  const getTopValue = () =>
    props.selectedBlock
      ? (props.selectedBlock.y / props.pageDimensions.height!) * 100 +
        ((props.selectedBlock.height! / props.pageDimensions.height!) * 100) / 2
      : '';

  const handleClick = (e: any) => {
    e.stopPropagation();
    props.onClick();
  };

  const showNextButton = () => {
    const { currentSelectedBlockIndex, documentIndex, documentId, selectedBlock } = props;
    if (
      (currentSelectedBlockIndex === null && documentIndex === 0) ||
      (selectedBlock && selectedBlock.documentId === documentId)
    ) {
      return true;
    }
    return false;
  };

  const nextButton = showNextButton() ? (
    <div
      ref={arrowRef}
      className={classes.nextButton}
      style={{
        top: `${getTopValue()}%`,
        right: isArrowInside ? undefined : '100%',
        left: isArrowInside && !IS_MOBILE ? 0 : undefined,
      }}
      onClick={handleClick}
      onTouchEnd={handleClick}
    >
      {props.selectedBlock !== undefined ? 'Next' : 'Start'}
    </div>
  ) : null;

  return nextButton;
};
